import { shotCards } from "@/mocks/evidence";

export default function ShotsSection() {
  return (
    <section id="shots" className="w-full bg-background-50">
      <div className="mx-auto w-full max-w-7xl px-4 py-10 md:px-6 md:py-16">
        <div className="flex flex-wrap items-end justify-between gap-4">
          <div className="max-w-2xl">
            <p className="eyebrow text-xs font-semibold text-primary-700">03 / 实锤截图</p>
            <h2 className="mt-3 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
              大图证据流 · 逐帧可放大
            </h2>
            <p className="mt-4 text-sm leading-7 text-foreground-600 md:text-[15px]">
              国产黑料实锤截图不只贴原图，更标注可疑处、裁切痕迹与来源时刻，避免「看图说话」。
            </p>
          </div>
          <a
            href="#pack"
            className="inline-flex items-center gap-2 whitespace-nowrap rounded-md border border-primary-300 px-4 py-2.5 text-sm text-primary-700 transition-colors hover:bg-primary-50"
          >
            <i className="ri-fullscreen-line" /> 全档查看
          </a>
        </div>

        <div className="mt-10 grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-3">
          {shotCards.map((s) => (
            <article
              key={s.id}
              className="group flex flex-col overflow-hidden rounded-lg border border-background-200 bg-background-100"
            >
              <div className="relative w-full overflow-hidden">
                <img
                  src={s.img}
                  alt={`国产黑料实锤截图 ${s.title}`}
                  className="h-52 w-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
                <span className="absolute left-3 top-3 rounded-md bg-primary-600 px-2.5 py-1 text-xs font-medium text-background-50">
                  {s.id}
                </span>
                <span className="absolute bottom-3 right-3 rounded-md bg-foreground-950/75 px-2.5 py-1 text-xs text-background-50 backdrop-blur-sm">
                  {s.date}
                </span>
              </div>
              <div className="flex flex-1 flex-col p-5">
                <span className="inline-flex items-center gap-1.5 text-xs font-medium text-primary-700">
                  <i className="ri-focus-2-line" /> {s.tag}
                </span>
                <h3 className="mt-2 font-heading text-lg font-semibold leading-snug text-foreground-950">
                  {s.title}
                </h3>
                <p className="mt-2 text-sm leading-6 text-foreground-600">{s.summary}</p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}